import React, { useEffect, useState } from 'react';
import { FieldComponent } from '../../../types/FieldComponent';
import { TimeFilter } from '../filters/TimeFilter';
import { debounce } from 'lodash';
import {
  Divider,
  IconButton,
  ListItem,
  ListItemAvatar,
  Stack,
  Typography,
} from '@mui/material';
import List from '@mui/material/List';
import api from '../../../services/api';
import { FileUploader } from 'react-drag-drop-files';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import ListItemText from '@mui/material/ListItemText';

import Avatar from '@mui/material/Avatar';
import Zoom from 'react-medium-image-zoom';
import 'react-medium-image-zoom/dist/styles.css';
import EditIcon from '@mui/icons-material/Edit';
import { SlidingPaneEdit } from '../../Page/SlidingPaneEdit';
import Tooltip from '@mui/material/Tooltip';
import FolderRoundedIcon from '@mui/icons-material/FolderRounded';

export const SingleFileField: FieldComponent<any, any> = ({
  onChange,
  isActive,
  value,
  allValue,
  hasTooltip,
  disabled,
  mui,
  column,
  schema,
  mainSchema,
  columnName,
  addingNewEntity,
  tab,
}) => {
  const [activities, setActivities] = React.useState<any>([]);
  const [manualConfirmations, setManualConformations] = React.useState<any>([]);
  const [tempActivities, setTempActivities] = useState<any>([]);
  const [files, setFiles] = useState<any>([]);
  const [softLoading, setSoftLoading] = useState<boolean>(false);
  const [openedSlidingPane, setOpenedSlidingPane] = useState<any>({});

  useEffect(() => {
    if (allValue?.roadbook){
      setManualConformations([allValue?.roadbook]);
    }
  }, [allValue?.roadbook]);
  const debouncedOnChange = debounce(handleDebouncedOnChange, 700);

  function handleDebouncedOnChange(
    value: any,
    event: any = null,
    index: any = null
  ) {
    handleChangeData(event, index, 'description', value);
    //onChange(value);
  }

  const handleChange = (newFiles: any) => {
    console.log(newFiles);

    const newFilesArray = [...[newFiles]];
    const oldFiles = [...files];
    newFilesArray.map((file: any) => {
      file.preview = URL.createObjectURL(file);
      oldFiles.push(file);
    });

    uploadFiles(newFilesArray);

    if (addingNewEntity) {
      onChange(oldFiles);
    }
  };

  const uploadFiles = (files: any) => {
    setSoftLoading(true);

    // Create a form and post it to server
    let formData = new FormData();
    files.forEach((file: any, i: any) => {
      formData.append(`file-${i}`, file);
    });

    formData.append(`column`, columnName||column?.columnName);
    formData.append(`id`, allValue?.id);
    formData.append(`schema`, JSON.stringify(mainSchema||schema));
    formData.append(`onlyOne`, 'true');

    api
      .postFile(`/upload-files`, formData)
      .then((res: any) => {
        const mC = [...manualConfirmations];
        res.map((item: any) => {
          mC.push(item);
        });
        setSoftLoading(false);
        setManualConformations(mC);
      })
      .catch((error: any) => {});
  };

  const handleChangeData = (
    event: any,
    index: any,
    columnName: string,
    value: any
  ) => {
    const newFiles = [...files];
    newFiles.map((row: any, rowIndex: number) => {
      if (index === rowIndex) {
        row[columnName] = value;
      }
      newFiles[rowIndex] = row;
    });
    setFiles(newFiles);
  };
  useEffect(() => {
    if (value) {
      setActivities(value);
    }
  }, [value]);
  const handleDeleteImage = (id: number) => {
    const newActivities = activities.filter((activity: any) => {
      return id !== activity.id;
    });
    onChange(newActivities);
  };

  return (
    <>
      <Stack
        sx={{
          opacity: softLoading ? 0.5 : 1,
          pointerEvents: softLoading ? 'none' : 'auto',
        }}
      >
        <FileUploader
          multiple={false}
          handleChange={handleChange}
          name="file"
          classes={'w-full !max-w-[100%] !min-w-[100px]'}
        />
      </Stack>
      <Divider />
      <List
        component="div"
        aria-labelledby="Files"
        sx={{
          opacity: softLoading ? 0.5 : 1,
          pointerEvents: softLoading ? 'none' : 'auto',
        }}
      >
        {manualConfirmations.map((item: any, index: number) => {
          return (
            <>
              <ListItem
                sx={{
                  borderBottom: '1px solid #f3f3f3',
                  padding: '8px',
                }}
                key={`list-images-${index}`}
                id={`list-images-${index}`}
              >
                <ListItemAvatar
                  sx={{
                    '& .MuiAvatar-root': {
                      border: '1px solid #e1e1e1',
                      borderRadius: '4px',
                      width: '50px',
                      height: '50px',
                    },
                  }}
                >
                  {item?.type.includes('image') ? (
                    <Zoom>
                      <Tooltip title={item?.name}>
                        <Avatar src={item?.link} alt={item?.name} />
                      </Tooltip>
                    </Zoom>
                  ) : (
                    <div
                      className={
                        'w-[50px] h-[50px] rounded-[4px] bg-[#e1e1e1] relative'
                      }
                    >
                      <FolderRoundedIcon
                        sx={{
                          color: '#b9b9b9',
                          position: 'absolute',
                          top: '50%',
                          left: '50%',
                          transform: 'translate(-50%,-50%)',
                        }}
                      />
                    </div>
                  )}
                </ListItemAvatar>
                <ListItemText
                  sx={{
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    width: '100%',
                  }}
                  secondary={
                    <React.Fragment>
                      <Tooltip title={item?.name}>
                        <Typography
                          variant={'caption'}
                          color={'gray'}
                          sx={{
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                          }}
                        >
                          {item?.name}
                        </Typography>
                      </Tooltip>
                    </React.Fragment>
                  }
                />
                <Stack
                  direction={'row'}
                  sx={{
                    width: '100px',
                  }}
                >
                  <IconButton
                    aria-label="edit"
                    size="small"
                    color={'primary'}
                    onClick={() => {
                      //handleDeleteImage(item?.id);
                      setOpenedSlidingPane({
                        schema: column?.tempSchema,
                        row: item,
                        tab: tab,
                      });
                    }}
                    key={`edit-button-${index}`}
                    id={`edit-button-${index}`}
                  >
                    <EditIcon fontSize="small" />
                  </IconButton>

                  <IconButton
                    aria-label="delete"
                    size="small"
                    color={'error'}
                    onClick={() => {
                      handleDeleteImage(item?.id);
                    }}
                    key={`delete-button-${index}`}
                    id={`delete-button-${index}`}
                  >
                    <DeleteIcon fontSize="small" />
                  </IconButton>
                </Stack>
              </ListItem>
            </>
          );
        })}
      </List>

      <Divider />

      {openedSlidingPane?.row?.id && (
        <SlidingPaneEdit
          schema={openedSlidingPane?.schema}
          id={openedSlidingPane?.row?.id}
          onSubmit={() => {}}
          propertiesFromTable={
            openedSlidingPane?.row ? openedSlidingPane?.row : {}
          }
          onClose={(valueFromPane) => {
            const newData = value.map((item: any) => {
              if (item?.id === valueFromPane?.id) {
                return valueFromPane;
              }
              return item;
            });
            onChange(newData);
            setOpenedSlidingPane({});
            return true;
          }}
        />
      )}
    </>
  );
};

SingleFileField.includes = (query, value) => true;

SingleFileField.comparator = () => 0;

SingleFileField.FilterRenderer = TimeFilter;
